import { gql } from 'apollo-angular';
import Organization from "../../../interfaces/organization";
import { Paginator, PaginatorInfo } from "../../../types/paginator";

type SearchOrganizationsResults = {
  search_organizations: Paginator<Organization, PaginatorInfo>
}
type SearchOrganizationsVariables = {
  searchLike: string;
  search: string;
  limit: number;
  page?: number|null;
}
export var nav_search_organizations = gql<SearchOrganizationsResults, SearchOrganizationsVariables>`
  query navSearchOrganizations(
    $searchLike: String!
    $search: String!
    $limit: Int!
    $page: Int
  ) {
    search_organizations(
      first: $limit
      name: $searchLike
      orderByInstr: [{ column: NAME, search: $search, order: ASC }]
      page: $page
    ) {
      data {
        id
        name
        entity {
          entity_types {
            type {
              name
              id
              tagType {
                name
              }
            }
          }
        }
      }
      paginatorInfo {
        currentPage
        lastPage
      }
    }
  }
`;
